import { Controller, useFormContext } from "react-hook-form";
import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import DisplayRateio from "./DisplayRateio";
import { enqueueSnackbar } from "notistack";

export default function Step04() {

    const { getValues, handleSubmit, control, watch } = useFormContext()
    const handleBack = getValues('funcoesAux.onBack')
    const handleNext = getValues('funcoesAux.onNext')
    const onSubmit = getValues('funcoesAux.onSubmit')
    const is_parcelado = watch('step02.is_parcelado')
    const addRateio = watch('step04.add_rateio') === 'true'

    const valoresSelect = [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' }
    ]

    const handleAvancar = (data: any) => {
        const { step04 } = getValues()
        if (step04.add_rateio === 'true' && step04.rateios.length === 0) {
            enqueueSnackbar("É necessário informar os centros de custo", { variant: "warning" })
            return
        }

        if (is_parcelado === 'true') onSubmit(data)
        if (is_parcelado === 'false') handleNext()
    }

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
                <Controller
                    name="step04.add_rateio"
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <FormControl fullWidth>
                            <FormLabel id={`adicionar-rateio`}>
                                Deseja dividir o valor em mais de um centro de custo?
                            </FormLabel>

                            <RadioGroup
                                {...field}
                                row
                                aria-labelledby="rateio-radio"
                            >
                                {
                                    valoresSelect.map((opcao, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={opcao.value}
                                            control={<Radio />}
                                            label={opcao.label}
                                        />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    )}
                />
            </Grid>

            {
                addRateio && (
                    <Grid size={{xs: 12}}>
                        <DisplayRateio />
                    </Grid>
                )
            }

            <Grid size={{xs: 12}}>
                <Box display={'flex'} gap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleBack}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(handleAvancar)}
                    >
                        {is_parcelado === 'true' ? 'Finalizar' : 'Avançar'}
                    </Button>
                </Box>
            </Grid>
        </Grid>
    )
}